"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReassignUsersForm = void 0;
var userSuggest_1 = require("../lib/userSuggest");
var buttons_1 = require("../buttons");
var React = require("react");
var ReassignUsersForm = (function (_super) {
    __extends(ReassignUsersForm, _super);
    function ReassignUsersForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReassignUsersForm.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "form-row" },
                React.createElement("div", { className: "form-group col-md-4" },
                    React.createElement("label", { htmlFor: "from_user" }, gettext("From user")),
                    React.createElement(userSuggest_1.UserSuggest, { objects: this.props.from_users_list, selected: this.props.selected_from_user, onChange: this.props.userChangeHandlerFrom, id: "from_user" })),
                React.createElement("div", { className: "form-group col-md-4" },
                    React.createElement("label", { htmlFor: "to_user" }, gettext("To user")),
                    React.createElement(userSuggest_1.UserSuggest, { objects: this.props.to_users_list, onChange: this.props.userChangeHandlerTo, id: "to_user" })),
                React.createElement("div", { className: "form-group col-md-4 align-self-end" },
                    React.createElement(buttons_1.Button, { fullWidth: true, noMargin: true, onClick: this.props.handleSubmit }, gettext("Reassign"))))));
    };
    return ReassignUsersForm;
}(React.Component));
exports.ReassignUsersForm = ReassignUsersForm;
